export default "__VITE_ASSET__HSv4dEnd__"